const styles = {
  container: {
    padding: "10px",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  list: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  listItem: {
    display: "block", // Use block display to stack items vertically
    padding: "8px 0",
    borderBottom: "1px solid #ddd",
  },
  fileInfo: {
    display: "flex",
    alignItems: "center",
  },
  fileText: {
    flexGrow: 1,
    marginRight: "8px",
  },
  revertButton: {
    padding: "4px 8px",
    fontSize: "0.9em",
    cursor: "pointer",
  },
  showDiffButton: {
    padding: "4px 8px",
    fontSize: "0.9em",
    cursor: "pointer",
    marginLeft: "4px",
  },
  diffContainer: {
    marginTop: "8px", // Adds some space between the file info and the diff view
    padding: "8px",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    borderRadius: "4px",
  },
};

export default styles;
